
import styled from "styled-components"
import close from "../assets/images/Close.svg"
import { SCREEN_SIZES } from "../constants"

const StyledBackdrop = styled.div`
    display: flex;
    position: fixed;
    opacity: ${props => props.visible ? 1 : 0};
    pointer-events: ${props => props.visible ? "all" : "none"};
    align-items: flex-start;
    z-index: 999;
    justify-content: center;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0, 0.5);
    width: 100%;
    height: 100%;
    transition: opacity 0.2s;
    overflow-y: scroll;
`;
const StyledContainer = styled.div`
    margin-top: 30px;
    background-color: white;
    width: ${props => props.width ? props.width : "50%"};
    max-width: 720px;
    border-radius: 10px;
    padding: 20px;
    transition: all 0.2s;
    position: relative;
   
    @media only screen and (max-width: ${SCREEN_SIZES.lg}) {
        width: 80%;
    
    }
    @media only screen and (max-width: ${SCREEN_SIZES.md}) {
        width: 100%;
        margin-top: 0;
        min-height: 100%;
        border-radius: 0;
    }

`;
const StyledClose = styled.img`
    transition: opacity 0.2s;
    cursor: pointer;
    :hover{
        opacity: 0.5;
    }
`;
export function Modal({ children, modalVisible, onClose, containerheight, width }) {

    return (
        <StyledBackdrop visible={modalVisible}>
            <StyledContainer containerheight={containerheight} width={width} >
                <div className="d-flex justify-content-end">
                    <StyledClose src={close} onClick={onClose} />
                </div>
                {children}
            </StyledContainer>

        </StyledBackdrop>
    );
}